'use strict';

function normalizePulseTab(tab) {
  if (tab === 'closeout') return 'closeout';
  return 'pulse';
}

export { normalizePulseTab };
